import React, { useState, useEffect, useContext } from 'react';
import styles from './style.module.scss';
import { Grid, Paper, Button, FormControl, TextField, Container, CircularProgress } from '@material-ui/core';
import { handleTypeNumber, emailValidator, nameValidator, OTPValidation, checkMobileNumber, CapitalizeFirstLetter } from '../../utils/validation';
import ModalComponent from '../../components/AlertComponent/modal';
import { generateOTP } from './signupApi';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Context as AuthContext } from '../../context/AuthContext';
import { useHistory, useLocation } from 'react-router-dom';

const SignUpPage = (props) => {
    const [userDetails, setUserDetails] = useState({
        mobileNo: null,
        emailId: null,
        otp: null,
        name: null
    });
    const [errorMsg, setErrorMsg] = useState({
        mobileNo: null,
        otp: null,
        name: null,
        email: null
    });
    const [disableOtpBtn, setDisableOtpBtn] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [errorToDisplay, setErrorToDisplay] = useState({
        msg: null,
        title: null,
        btn1: null,
        btn2: null,
        btn1Handle: null,
        btn2Handle: null,
        path: null
    })
    const [otpLoader, setOtpLoader] = useState(false);
    const [timeLeft, setTimeLeft] = useState();
    const [otpGenerated, setOtpGenerated] = useState(false);
    const [enableResend, setEnableResend] = useState(false);
    const [signupLoader, setSignupLoader] = useState(false);
    let intervalId;
    const { signup } = useContext(AuthContext);
    let history = useHistory();
    let location = useLocation();

    useEffect(() => {
        if (!timeLeft) {
            clearInterval(intervalId);
            setOtpGenerated(false);
        }
        else {
            intervalId = setInterval(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);
        }
        return () => clearInterval(intervalId);
    }, [timeLeft]);


    //function to handle input changes
    const inputChange = (e) => {
        let details = { ...userDetails };
        let msg = { ...errorMsg };
        msg[e.target.name] = null;
        details[e.target.name] = e.target.value;
        if (e.target.name === 'mobileNo') {
            if (e.target.value.length === 10) {
                setDisableOtpBtn(false);
            }
            else {
                setDisableOtpBtn(true);
            }
        }
        setUserDetails(details);
        setErrorMsg(msg);
    }

    //function to handle input validation
    const checkValidation = (e) => {
        let msg = { ...errorMsg };
        if (e.target.name === 'name') {
            let result = nameValidator(e.target.value);
            if (result) {
                msg[e.target.name] = (result === 'empty') ? `${CapitalizeFirstLetter(e.target.name)} is required.` : `Only characters allowed!`;
            }
            else {
                msg[e.target.name] = null;
            }
        }
        else if (e.target.name === 'email') {
            let result = emailValidator(e.target.value);
            if (result) {
                msg[e.target.name] = result;
            }
            else {
                msg[e.target.name] = null;
            }
        }
        else if (e.target.name === 'mobileNo') {
            let result = checkMobileNumber(e.target.value);
            if (result) {
                msg[e.target.name] = result;
            }
            else {
                msg[e.target.name] = null;
            }
        }
        else if (e.target.name === 'otp') {
            let result = OTPValidation(e.target.value);
            if (result) {
                msg[e.target.name] = result;
            }
            else {
                msg[e.target.name] = null;
            }
        }
        setErrorMsg(msg);
    }

    //function to sign up user
    const signUpFnc = async () => {
        setSignupLoader(true);
        let data = { username: userDetails.mobileNo, otp: userDetails.otp, full_name: userDetails.name, email: userDetails.email };
        const signUpResp = await signup(data);
        if (signUpResp && signUpResp.data.status === 'success') {
            setSignupLoader(false);
            localStorage.setItem('requestId', signUpResp.data.data.request_id);
            history.push({ pathname: "/registration", state: signUpResp.data.data });
        }
        else {
            setSignupLoader(false);
            let error = { ...errorToDisplay };
            error.msg = signUpResp.data.msg;
            error.title = 'Error';
            error.btn1 = '';
            error.btn2 = 'Okay';
            error.btn2Handle = handleModalClose;
            setErrorToDisplay(error);
            setShowModal(true);
        }
    }

    //function to handle modal close
    const handleModalClose = () => {
        setShowModal(false);
    }

    //function to generate otp
    const sendOtp = async () => {
        setOtpLoader(true);
        let data = { username: userDetails.mobileNo, isWoSeller: true };
        await generateOTP(data.username, data.isWoSeller)
            .then(res => {
                if (res && res.data.status === 'success') {
                    if (res.data.reg_status === 'wo_seller_unregistered') {
                        setTimeLeft(30);
                        setOtpLoader(false);
                        setOtpGenerated(true);
                        setEnableResend(true);
                    }
                    else if (res.data.reg_status === 'wo_seller_pending') {
                        let error = { ...errorToDisplay };
                        error.msg = 'Looks like you have already created an account. Procced with registration.';
                        error.title = '';
                        error.btn1 = 'Cancel';
                        error.btn2 = 'Okay';
                        error.path = '/registration';
                        error.btn2Handle = navigate;
                        setErrorToDisplay(error);
                        setShowModal(true);
                        setOtpLoader(false);
                    }
                    else if (res.data.reg_status === 'wo_seller_requested') {
                        let error = { ...errorToDisplay };
                        error.msg = 'Your account is under review. We will notify you, once your application is approved.';
                        error.title = '';
                        error.btn1 = '';
                        error.btn2 = 'Okay';
                        error.btn2Handle = handleModalClose;
                        setErrorToDisplay(error);
                        setShowModal(true);
                        setOtpLoader(false);
                    }
                    else if (!res.data.reg_status) {
                        let error = { ...errorToDisplay };
                        error.msg = 'Looks like you have already created an account. Login in to start selling.';
                        error.title = '';
                        error.btn1 = 'Cancel';
                        error.btn2 = 'Login';
                        error.path = '/login';
                        error.btn2Handle = navigate;
                        setErrorToDisplay(error);
                        setShowModal(true);
                        setOtpLoader(false);
                    }
                }
                else {
                    let error = { ...errorToDisplay };
                    error.msg = res.data.msg;
                    error.title = 'Error';
                    setErrorToDisplay(error);
                    setShowModal(true);
                    setOtpLoader(false);
                }
            })
            .catch((error) => {
                console.log(error);
                setOtpLoader(false);
            });
    }

    //function to check form validation
    const checkFormValidation = () => {
        if (errorMsg.mobileNo || !userDetails.mobileNo || errorMsg.otp || !userDetails.otp || errorMsg.name || !userDetails.name || errorMsg.email || !userDetails.email) {
            return false
        }
        else
            return true
    }

    //function to handle navigation
    const navigate = () => {
        let { from } = location.state || { from: { pathname: errorToDisplay.path } };
        history.replace(from);
    }

    return <div className={styles.mainContainer}>
        <div className="d-flex justify-content-between align-items-center">
            <div>
                <img src="/images/GoStor_main.svg" alt="logo" width="80px" height="auto" />
            </div>
            <div>
                <div className="d-flex align-items-center">
                    <span>Already have an account?</span>
                    <Button variant="outlined" color="primary" className="ml-2" onClick={() => history.replace('/login')}>Login</Button>
                </div>
            </div>
        </div>
        <Container maxWidth="md" className={styles.parentContainer}>
            <Paper spacing={4} >
                <Grid container  >
                    <Grid item xs={12} sm={6} md={6} className={`${styles.paperContainer} ${styles.borderContainer}`} >
                        <h5 style={{ color: '#389203' }}>Create your seller account on Gostor and grow your business.</h5>
                        <div className="pt-5">
                            <h6 className="pb-3 mb-0">All you need is </h6>
                            <div className="d-flex align-items-center">
                                <div><ArrowForwardIcon color="primary" /></div>
                                <div className="pl-2"><strong>GSTIN</strong></div> </div>
                            <div className="d-flex align-items-center">
                                <div><ArrowForwardIcon color="primary" /></div>
                                <div className="pl-2 "> <strong>Active Bank Account</strong> </div> </div>
                            <div className="pt-3">and you will just be a few clicks away to start your journey with us.</div>

                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className={styles.paperContainer}>
                        <Grid container spacing={4} >
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControl fullWidth >
                                    <TextField
                                        required
                                        inputProps={{
                                            autoComplete: 'off'
                                        }}
                                        error={errorMsg.name ? true : false}
                                        helperText={errorMsg.name}
                                        name="name" id="name" label="Enter Your Name"
                                        value={userDetails.name || ''}
                                        onChange={(e) => inputChange(e)}
                                        onBlur={(e) => checkValidation(e)} />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={4} >
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControl fullWidth >
                                    <TextField
                                        inputProps={{
                                            autoComplete: 'none'
                                        }}
                                        required
                                        error={errorMsg.email ? true : false} helperText={errorMsg.email}
                                        name="email" id="email" label="Enter Email Id"
                                        value={userDetails.email || ''}
                                        onChange={(e) => inputChange(e)}
                                        onBlur={(e) => checkValidation(e)} />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={4} alignItems="flex-end">
                            <Grid item xs={12} sm={12} md={7}>
                                <FormControl fullWidth >
                                    <TextField
                                        inputProps={{
                                            autoComplete: 'none'
                                        }}
                                        required type="number" name="mobileNo" id="mobileNo" label="Enter Mobile Number"
                                        error={errorMsg.mobileNo ? true : false}
                                        helperText={errorMsg.mobileNo}
                                        onKeyDown={(evt) => handleTypeNumber(evt)}
                                        value={userDetails.mobileNo || ''}
                                        onChange={(e) => inputChange(e)}
                                        onBlur={(e) => checkValidation(e)} />
                                </FormControl>
                            </Grid>
                            {
                                !enableResend ?
                                    <Grid item md >
                                        <Button variant="outlined" color="primary" disabled={disableOtpBtn || otpLoader} className={`${disableOtpBtn || otpLoader ? styles.disableBtn : null}  ${styles.otpBtn}`} style={{ width: '100%' }} onClick={() => !otpLoader && !disableOtpBtn ? sendOtp() : null}>
                                            Send OTP
                                            {otpLoader ? <CircularProgress className="ml-2" size={15} /> : null}</Button>
                                    </Grid>
                                    :
                                    <Grid item md >
                                        <Button variant="outlined" color="primary" disabled={disableOtpBtn || otpLoader || otpGenerated} className={`${disableOtpBtn || otpLoader || otpGenerated ? styles.disableBtn : null} ${styles.otpBtn}`} disableFocusRipple={disableOtpBtn} disableRipple={disableOtpBtn} style={{ width: '100%' }} onClick={() => !otpLoader && !disableOtpBtn && !otpGenerated ? sendOtp() : null}>
                                            Resend OTP
                                            {otpLoader ? <CircularProgress className="ml-2" size={10} /> : null}</Button>
                                    </Grid>
                            }
                            {otpGenerated ?
                                <Grid container spacing={0} id={styles.expiryCont}>
                                    <small className="text-muted text-right">Resend OTP in {timeLeft} seconds </small>
                                </Grid>
                                : null
                            }
                        </Grid>
                        {enableResend ?
                            <Grid container spacing={4} >
                                <Grid item xs={12} sm={12} md={12}>
                                    <FormControl fullWidth >
                                        <TextField
                                            inputProps={{
                                                autoComplete: 'off'
                                            }}
                                            required type="number" name="otp" id="otp" label="Enter OTP"
                                            error={errorMsg.otp ? true : false}
                                            helperText={errorMsg.otp}
                                            onKeyDown={(evt) => handleTypeNumber(evt)}
                                            value={userDetails.otp || ''}
                                            onChange={(e) => inputChange(e)}
                                            onBlur={(e) => checkValidation(e)} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            : null}
                        <Grid container spacing={5} className={styles.btnWrapper}>
                            {/* <small className={styles.termText}>By clicking on Sign up, you agree to our <a style={{ textDecoration: 'underline' }}>Terms and Conditions</a></small> */}
                            <Button variant="contained" color="primary" className={`${!checkFormValidation() || signupLoader ? styles.disableBtn : styles.btnComp}`} style={{ width: '100%' }} disabled={!checkFormValidation() || signupLoader} onClick={() => checkFormValidation() ? signUpFnc() : null}>Sign Up
                                {signupLoader ? <CircularProgress className="ml-2" size={15} style={{ color: 'white' }} /> : null}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
        <ModalComponent
            msg={errorToDisplay.msg}
            title={errorToDisplay.title}
            btn1Text={errorToDisplay.btn1}
            btn2Text={errorToDisplay.btn2}
            show={showModal}
            handleBtn1={handleModalClose}
            handleBtn2={errorToDisplay.btn2Handle}
            handleModalClose={handleModalClose} />
    </div>
}

export default SignUpPage;